/*
 * This file is part of the Det Norske Teatret application.
 *
 * (c) APT AS
 *
 * For the full copyright and license information, please view the LICENSE
 * file that was distributed with this source code.
 */

import React, { useEffect } from 'react';
import PropTypes from 'prop-types';
import classnames from 'classnames';
import inView from 'effects/inview';
import './Text.scss';

function Paragraph({ children }) {
  const [ref, inview] = inView({
    rootMargin: '-30% 0px -20% 0px',
    threshold: [0.1, 0.9],
  });

  return (
    <p
      ref={ref}
      className={classnames({ inview })}
      dangerouslySetInnerHTML={{ __html: children }}
    />
  );
}

/**
 * Declare expected prop types.
 *
 * @type {Object}
 */
Paragraph.propTypes = {
  children: PropTypes.string,
};

/**
 * This is the Text component.
 *
 * @author Thomas Sømoen <thomas@apt.no>
 *
 * @return {JSX}
 */
function Text({ text, onInview }) {
  const [ref, inview] = inView({ threshold: [0.1, 0.9] });

  useEffect(() => {
    if (inview) {
      onInview();
    }
  }, [inview]);

  return (
    <div ref={ref} className="text">
      {text.length ? <Paragraph>{text}</Paragraph> : null}
    </div>
  );
}

/**
 * Declare expected prop types.
 *
 * @type {Object}
 */
Text.propTypes = {
  text: PropTypes.string,
  onInview: PropTypes.func.isRequired,
};

/**
 * Declare defaults for non-required props.
 *
 * @type {Object}
 */
Text.defaultProps = {
  text: '',
  onInview: () => {},
};

export default Text;
